"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const PlanetaryTrackReward_vue_1 = __importDefault(require("./PlanetaryTrackReward.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'PlanetaryTrackRewards',
    props: {
        rewards: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
    },
    components: {
        PlanetaryTrackReward: PlanetaryTrackReward_vue_1.default,
    },
    data() {
        return {};
    },
    computed: {
        myReward() {
            switch (this.type) {
                case 'risingPlayer':
                    return this.rewards.risingPlayer;
                case 'everyone':
                    return this.rewards.everyone.concat(this.rewards.mostTags);
                default:
                    return [];
            }
        },
        mostTags() {
            return this.type === 'everyone' && this.rewards.mostTags.length > 0;
        },
    },
});
